import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MANIFESTO, IMAGES } from "../lib/site";
import { useSite, siteImg } from "../context/SiteContext";

const Chapter = ({ item, index }) => {
  const flip = index % 2 === 1;
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
      data-testid={`manifesto-chapter-${item.n}`}
      className={`grid md:grid-cols-12 gap-6 md:gap-12 items-start py-12 border-t border-white/[0.06]`}
    >
      <div className={`md:col-span-3 ${flip ? "md:order-2 md:text-right" : ""}`}>
        <span className="font-serif text-6xl md:text-8xl font-light gold-text leading-none">{item.n}</span>
      </div>
      <div className={`md:col-span-9 ${flip ? "md:order-1" : ""} ${flip ? "md:pr-16" : "md:pl-4"}`}>
        <h3 className="font-serif text-3xl md:text-4xl font-normal tracking-tight text-white mb-4">
          {item.title}
        </h3>
        <p className="text-[#A3A3A3] font-light text-base lg:text-lg leading-relaxed max-w-2xl">
          {item.body}
        </p>
      </div>
    </motion.div>
  );
};

export const Manifesto = () => {
  const site = useSite();
  const { scrollYProgress } = useScroll();
  const y = useTransform(scrollYProgress, [0, 1], [0, -120]);

  return (
    <section id="manifesto" data-testid="manifesto-section" className="py-24 md:py-32 lg:py-40 relative">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-24">
        <div className="lg:col-span-8">
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-gold">La vision</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 mb-8 leading-tight">
            Construite par les <span className="gold-text">meilleurs</span>.
            <br />Propulsée au monde.
          </h2>

          <div>
            {MANIFESTO.map((item, i) => (
              <Chapter key={item.n} item={item} index={i} />
            ))}
          </div>
        </div>

        <div className="lg:col-span-4 relative hidden lg:block">
          <motion.div style={{ y }} className="sticky top-32">
            <div className="relative aspect-[3/4] overflow-hidden border border-white/[0.08]">
              <img src={siteImg(site, "manifesto", IMAGES.manifesto)} alt="" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-base/60 to-transparent" />
            </div>
            <p className="font-serif text-2xl text-white/80 mt-6 leading-snug">
              « L'art d'abord. La vitesse ensuite. »
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
